const { Schedule } = require('./Schedule.js')

class ScheduleTemplate {
  constructor(
    id='',
    typeId='',
    addonLogic=[],
    shortDescription='',
    longDescription='',
    thickness='', material='', equip='', process='',
    priority=1, assignTo='',
    dependency=[],
    timeFormula='',
    prematureRelease=false,
    orderIndex=0,
  ) {
    this.id = id
    this.type_id = typeId
    this.addon_logic = addonLogic
    this.short_description = shortDescription
    this.long_description = longDescription
    this.thickness = thickness
    this.material = material
    this.equip = equip
    this.process = process
    this.priority = priority
    this.assign_to = assignTo
    this.dependency = dependency
    this.time_formula = timeFormula
    this.premature_release = prematureRelease
    this.order_index = orderIndex
  }

  static from(json) {
    const template = Object.assign(new ScheduleTemplate(), json)
    template.dependency = JSON.parse(JSON.stringify(template.dependency || []))
    template.addon_logic = JSON.parse(JSON.stringify(template.addon_logic || []))
    return template
  }

  toSchedule() {
    const jsonSchedule = JSON.parse(JSON.stringify(this))
    return Schedule.from(jsonSchedule)
  }
}

/**
 * Evaluate a DNF addon_logic expression against a sign.
 * [] → matches all (type-level). Outer = OR, inner = AND.
 * Each literal: {addon_id, labels, is_not}
 */
function matchesDNF(addonLogic, sign) {
  if (!addonLogic || addonLogic.length === 0) return true
  return addonLogic.some(clause =>
    clause.length > 0 && clause.every(literal => {
      const signAddon = (sign.addons || []).find(a => a.id === literal.addon_id)
      const labelMatch = !literal.labels || literal.labels.length === 0
        || (signAddon && literal.labels.some(l => signAddon.label.includes(l)))
      const positive = !!signAddon && labelMatch
      return !!literal.is_not ? !positive : positive
    })
  )
}

/**
 * Generate schedules for a quote based on templates.
 * @param {Quote} quote
 * @param {[ScheduleTemplate]} templates
 * @return {[Schedule]}
 */
function GenerateSchedules(quote, templates=[]) {
  const schedules = []
  for (const sign of quote.signs) {
    const typeTemplates = templates.filter(t => t.type_id === sign.type.id)
    for (const tmpl of typeTemplates) {
      if (!matchesDNF(tmpl.addon_logic, sign)) continue
      const schedule = tmpl.toSchedule()
      schedule.quote_id = quote.id
      schedule.sign_ids = [sign.id]
      schedules.push(schedule)
    }
  }
  return schedules
}

/**
 * Renders a DNF addon_logic expression as a human-readable AND/OR string,
 * e.g. "Backer AND (Halo OR Perimeter)". Returns null for an unconditional
 * (empty) addon_logic.
 * @param {[[{addon_id, labels, is_not}]]} addonLogic
 * @param {[object]} addons - addon objects with {id, cost_label}
 * @return {?string}
 */
function addonLogicToString(addonLogic, addons) {
  if (!addonLogic || addonLogic.length === 0) return null
  const addonName = (id) => (addons.find(a => a.id === id) || {}).cost_label || '?'
  const clauseStr = (clause) => clause
    .map(lit => (lit.is_not ? 'NOT ' : '') + addonName(lit.addon_id))
    .join(' AND ')
  const clauses = addonLogic.map(clauseStr)
  return clauses.length > 1 ? clauses.map(c => `(${c})`).join(' OR ') : clauses[0]
}

module.exports = {
  ScheduleTemplate,
  GenerateSchedules,
  addonLogicToString,
}
